<template>
    <div class="c-section -white || o-padding -big-top -huge-bottom" data-scroll-section>
        <div class="o-container">
            <div class="o-grid -col-4 -col-8@from-medium -gutters c-sticky_section">
                <div id="target" class="c-sticky_target"></div>
                <div class="o-grid_item u-gc-1/4@from-medium">
                    <div class="o-padding -medium-bottom -no-padding-bottom@from-medium c-sticky_element" data-scroll data-scroll-sticky data-scroll-target="#target" data-scroll-position="top">
                        <figure class="c-figure -lazy-load -no-bg || c-text-illu_figure -form || o-padding -medium-bottom -no-padding-bottom@from-medium">
                            <div class="c-figure_inner">
                                <img class="c-figure_image" :src="'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 ' + image.width + ' ' + image.height + '\'%3E%3C/svg%3E'" :data-src="image.url" alt="" :width="image.width" :height="image.height" data-scroll data-scroll-call="lazyLoad, Scroll">
                            </div>
                        </figure>
                    </div>
                </div>
                <div class="o-grid_item u-gc-5/9@from-medium">
                    <form v-if="submited != true" ref="form$" @submit.prevent="checkForm" class="c-form" novalidate="true" :class="{ 'is-form-invalid': formInvalid, 'is-loading': loading, 'is-submited': submited }">

                        <template v-if="step == 1">
                            <h1 class="c-heading-decorative -editorial -size-smaller || o-margin -tiny-bottom">
                                {{ _t("Let’s Get Started") }}
                            </h1>
                            <p class="o-margin -large-bottom">
                                {{ _t("Accept credit cards in your store, on the go, or online.") }}
                            </p>
                            <div class="c-form_title">
                                {{ _t("Credit cards") }}
                            </div>

                            <RadioInput v-model="form.Do_you_accept_credit_cards_now" id="Do_you_accept_credit_cards_now" name="Do_you_accept_credit_cards_now" :labelText="_t('Do you accept credit cards now?')" :choices="[
                                { id: 'creditCardsYes', value: 'YES', label: _t('Yes') },
                                { id: 'creditCardsNo', value: 'NO', label: _t('No') }
                            ]" required />

                            <div class="c-form_controls">
                                <div class="c-form_button_group">
                                    <button class="c-form_button_back" type="button" disabled>
                                        {{ _t("Back") }}
                                    </button>
                                    <button class="c-form_button_next" type="button" @click="nextStep(2)">
                                        {{ _t("Next") }}
                                    </button>
                                </div>
                                <div class="c-form_progress">
                                    {{ _t("Step") + " 1 " + _t("of") + " " + steps.length }}
                                </div>
                            </div>
                        </template>

                        <template v-if="step == 2">
                            <div class="c-form_title">
                                {{ _t("Processing method") }}
                            </div>
                            <CheckboxInput v-model="form.Processing_Method" id="Processing_Method" name="Processing_Method" :labelText="_t('Choose your processing method')" :choices="[
                                { id: 'processingMethodInPerson', value: 'Counter top Credit Card Terminal', label: _t('Counter top Credit Card Terminal') },
                                { id: 'processingMethodOnline', value: 'Wireless Credit Card Terminal', label: _t('Wireless Credit Card Terminal') },
                                { id: 'processingMethodBoth', value: 'Online Processing', label: _t('Online Processing') }
                            ]" required />

                            <div class="c-form_controls">
                                <div class="c-form_button_group">
                                    <button class="c-form_button_back" type="button" @click="previousStep(1)">
                                        {{ _t("Back") }}
                                    </button>
                                    <button class="c-form_button_next" type="button" @click="nextStep(3)">
                                        {{ _t("Next") }}
                                    </button>
                                </div>
                                <div class="c-form_progress">
                                    {{ _t("Step") + " 2 " + _t("of") + " " + steps.length }}
                                </div>
                            </div>
                        </template>

                        <template v-if="step == 3">
                            <div class="c-form_title">
                                {{ _t("Tell Us About You") }}
                            </div>
                            <!-- Name -->
                            <div class="c-form_item">
                                <label for="Name" class="c-form_label -required">{{ _t('Name') }}</label>
                                <div class="c-form_item_group -group-1/2">
                                    <TextInput v-model="form.First_Name" :labelText="_t('First name')" id="FirstName" name="FirstName" required labelUnder/>
                                </div>
                                <div class="c-form_item_group -group-1/2">
                                    <TextInput v-model="form.Last_Name" :labelText="_t('Last name')" id="LastName" name="LastName" required labelUnder/>
                                </div>
                            </div>

                            <div class="c-form_item">
                                <EmailInput v-model="form.Email" id="Email" name="Email" required :labelText="_t('Email')" />
                            </div>

                            <div class="c-form_item">
                                <TextInput v-model="form.Temp_Company" id="CompanyName" name="CompanyName" required :labelText="_t('Company Name')" />
                            </div>

                            <div class="c-form_item">
                                <PhoneInput v-model="form.Phone" id="Phone" name="Phone" required :labelText="_t('Phone')" />
                            </div>

                            <!-- Country -->
                            <div class="c-form_item">
                                <SelectInput v-model="form.Business_Location" id="Country" name="Business_Location" required="true" :labelText="_t('Company location')" :options="[
                                    { value: 'Canada', text: 'Canada' },
                                    { value: 'USA', text: _t('USA') },
                                ]" />
                            </div>

                            <div class="c-form_item">
                                <SelectInput v-model="form.Current_Credit_Volume" id="MonthlyVolume" name="MonthlyVolume" required :labelText="_t('Monthly Volume')" :options="[
                                    { value: 49000, text: _t('Less than $50 000') },
                                    { value: 50000, text: _t('$50 000 to $200 000') },
                                    { value: 200001, text: _t('$200 001 to $500 000') },
                                    { value: 500001, text: _t('$500 001 to $1 000 000') },
                                    { value: 1000001, text: _t('$1 000 001 to $2 500 000') },
                                    { value: 2500001, text: _t('$2 500 001 to $5 000 000') },
                                    { value: 5000001, text: _t('$5 000 001 +') }
                                ]" />
                            </div>

                            <div class="c-form_controls">
                                <div class="c-form_button_group">
                                    <button class="c-form_button_back" type="button" @click="previousStep(2)">
                                        {{ _t("Back") }}
                                    </button>
                                    <button class="c-form_button_next" type="button" @click="nextStep(4)">
                                        {{ _t("Next") }}
                                    </button>
                                </div>
                                <div class="c-form_progress">
                                    {{ _t("Step") + " 3 " + _t("of") + " " + steps.length }}
                                </div>
                            </div>
                        </template>

                        <template v-if="step == 4">
                            <div class="c-form_title">
                                {{ _t("How soon do you need to get started?" ) }}
                            </div>

                            <div class="c-form_item">
                                <SelectInput v-model="form.How_soon_do_you_need_to_get_started" id="How_soon_do_you_need_to_get_started" name="How_soon_do_you_need_to_get_started" required :labelText="_t('How soon do you need to get started?')" :options="[
                                    { value: 'Less than a week', text: _t('Less than a week') },
                                    { value: '1-2 Weeks', text: _t('1-2 Weeks') },
                                    { value: '3-6 Weeks', text: _t('3-6 Weeks') },
                                    { value: '7+ Weeks', text: _t('7+ Weeks') }
                                ]" />
                            </div>

                            <div class="c-form_controls">
                                <div class="c-form_button_group">
                                    <button class="c-form_button_submit" type="submit">
                                        <span class="c-form_button_spinner"></span>
                                        {{ _t("Get Solution") }}
                                    </button>
                                </div>
                            </div>

                            <div class="c-form_legal" v-html="completion_text"></div>
                        </template>
                    </form>
                    <div v-if="submited==true" class="c-form_success">
                        <div class="c-form_title">
                            {{ _t("Thank you") }}
                        </div>
                        <div class="c-form_success_title">
                            {{ _t("Your information has been submitted") }}
                        </div>
                        <div class="c-form_success_text">
                            {{ _t("We will be in touch shortly") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="submited!=true" data-scroll-section>
        <div class="c-form_stepper -relative">
            <div v-for="s in steps" class="c-form_stepper_step" :class="{ 'is-complete': s.complete, 'is-active': s.id == step }">
                <Image id="complete" />
                <span>
                    {{ s.name }}
                </span>
            </div>
        </div>
    </div>

    <div v-if="submited!=true" class="c-form_stepper">
        <div v-for="s in steps" class="c-form_stepper_step" :class="{ 'is-complete': s.complete, 'is-active': s.id == step }">
            <Image id="complete" />
            <span>
                {{ s.name }}
            </span>
        </div>
    </div>
</template>
<script>
import Image from './partials/Image.vue';
import RadioInput from './inputs/radio.vue';
import CheckboxInput from './inputs/checkbox.vue';
import TextInput from './inputs/text.vue';
import EmailInput from './inputs/email.vue';
import PhoneInput from './inputs/phone.vue';
import SelectInput from './inputs/select.vue';
const randomImage = ASSETS.randomImage;

    export default {
        name: 'SalesWebsiteComponents',
        props: {
            completion_text: String
        },
        data() {
            return {
                steps: [
                    { id: 1, name: this._t('Credit cards'), complete: false },
                    { id: 2, name: this._t('Processing method'), complete: false },
                    { id: 3, name: this._t('Tell Us About You'), complete: false },
                    { id: 4, name: this._t('How soon do you need to get started'), complete: false }
                ],
                step: 1,
                formInvalid: false,
                loading: false,
                submited: false,
                image: randomImage,
                form: {
                    First_Name: '',
                    Last_Name: '',
                    Email: '',
                    Phone: '',
                    Temp_Company: '',
                    Business_Location: '',
                    Current_Credit_Volume: '',
                    Processing_Method: '',
                    Do_you_accept_credit_cards_now: '',
                    How_soon_do_you_need_to_get_started: '',
                    Lead_Source: 'Website',
                    Lead_Status: 'Lead Created',
                    Owner: {
                        id: '3992999000000211013'
                    },
                    Language: this.$root.lang.toUpperCase()
                },
            }
        },
        components: {
            Image,
            RadioInput,
            CheckboxInput,
            TextInput,
            EmailInput,
            PhoneInput,
            SelectInput
        },
        mounted() {

            //console.log('Sales Website Component mounted.')
        },
        methods: {
            checkForm(e) {
                this.loading = true;
                this.formInvalid = false;
                //Validate form manually
                let form = this.$refs.form$;
                let isValid = form.checkValidity();
                if (!isValid) {
                    this.formInvalid = true;
                    this.loading = false;
                } else {
                    this.submitForm(e);
                }
            },
            async submitForm(e) {
                //implode processing method
                this.form.Processing_Method = this.form.Processing_Method.join(', ');
                let data = {
                    'form': this.form,
                    'module': 'Leads'
                };
                let response = await fetch('/wp-json/pandapay/v1/submit_custom_form', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                });
                //response = await response.json();
                //console.log(response);

                if(response.ok == true) {
                    this.submited = true;
                    e.target.reset();
                } else {
                    this.submited = false;
                    this.loading = false;
                }
                this.loading = false;
                this.submited = true;
            },
            nextStep(step) {
                this.formInvalid = false;
                let valid = this.$refs.form$.checkValidity();
                if (valid) {
                    this.step = step;
                    this.steps.forEach(s => {
                        if (s.id == step-1) {
                            s.complete = true;
                        }
                    });
                    this.modu.call('scrollTo', { target: '#target', offset: -100 }, 'Scroll');
                } else {
                    this.formInvalid = true;
                }
            },
            previousStep(step) {
                this.step = step;
                this.steps.forEach(s => {
                    if (s.id == step) {
                        s.complete = false;
                    }
                });
                this.modu.call('scrollTo', { target: '#target', offset: -100 }, 'Scroll');
            },
        },
        watch: {
           'form' : {
               handler: function () {
                   //Check if form is valid
                    let form = this.$refs.form$;
                    let isValid = form.checkValidity();
                    if (isValid) {
                        this.formInvalid = false;
                    } 
               },
               deep: true
           }
        }
    }
</script>